module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/auth/auth.component.html
// module id = ../../../../../src/app/auth/auth.component.html
// module chunks = main